<select class="form-control dropdown-toggle header-language-selector" [(ngModel)]='selectedVoice'
    (change)="changeVoiceEnable($event)">
    <option [value]=true>{{'voice_enable' |translate |async}}</option>
    <option [value]=false>{{'voice_disable' |translate |async}}</option>
</select>